import { createGlobalStyle, css, styled } from 'styled-components';

import { SCREEN_SIZE } from '@components/web/src/styles';

export const GlobalMockBackground = createGlobalStyle`
  html::before {
    content: '';
    position: fixed;
    inset: 0;
    z-index: -1;
    background-color: rgba(52, 64, 84, 0.6);
  }

  html,
  body {
    background: none;
    margin: 0;
    padding: 0;
    height: 100%;
  }   
`;

export const RootContainer = styled.div<{ $isMocked?: boolean }>`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  container-type: inline-size;
  container-name: rootContainer;

  ${({ theme, $isMocked }) =>
    theme?.isKioskRootElementType
      ? css`
          height: 100vh;
          max-width: 100%;

          ${$isMocked &&
          css`
            height: ${SCREEN_SIZE.KIOSK_HEIGHT};
            max-width: ${SCREEN_SIZE.KIOSK_WIDTH};
          `}
        `
      : css`
          height: 100svh !important;

          ${$isMocked &&
          css`
            @media (min-width: ${SCREEN_SIZE.MOBILE_WIDTH}) {
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              display: flex;
              flex-direction: column;
              align-items: center;
              max-width: ${SCREEN_SIZE.MOBILE_WIDTH};
              min-height: 84vh !important;
              max-height: 84vh !important;
              margin: 0 auto;
              border-radius: 8px;
              overflow: hidden;
            }
          `}
        `}
`;
